import {addLocaleData} from 'react-intl';
import {getHomeworkInfo} from '../lib/homework-info';

import {localeData} from '@hetao/scratch-l10n';
import editorMessages from '@hetao/scratch-l10n/locales/editor-msgs';
import RtlLocales from '../lib/rtl-locales';
addLocaleData(localeData);

const UPDATE_LOCALES = 'scratch-gui/locales/UPDATE_LOCALES';
const SELECT_LOCALE = 'scratch-gui/locales/SELECT_LOCALE';

const initialState = {
    isRtl: false,
    locale: 'en',
    messagesByLocale: editorMessages,
    messages: editorMessages.en
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SELECT_LOCALE:
        return Object.assign({}, state, {
            isRtl: RtlLocales.indexOf(action.locale) !== -1,
            locale: action.locale,
            messagesByLocale: state.messagesByLocale,
            messages: state.messagesByLocale[action.locale]
        });
    case UPDATE_LOCALES:
        return Object.assign({}, state, {
            isRtl: state.isRtl,
            locale: state.locale,
            messagesByLocale: action.messagesByLocale,
            messages: action.messagesByLocale[state.locale]
        });
    default:
        return state;
    }
};

const selectLocale = function (locale) {
    // const locale = locale === 'en' ? 'en' : 'zh-cn';
    const homeworkInfo = getHomeworkInfo();
    const courseId = Number(homeworkInfo.courseId);
    const unitId = Number(homeworkInfo.unitId);
    const lessonId = Number(homeworkInfo.lessonId);
    ht.track('s3_lang_switch', {
        context: {
            courseId: courseId,
            unitId: unitId,
            lessonId: lessonId,
            currentUrl: location.href,
            stageDisplayMode: localStorage.getItem('stageDisplayMode')
        }
    });
    return {
        type: SELECT_LOCALE,
        locale: locale
    };
};

const setLocales = function (localesMessages) {
    return {
        type: UPDATE_LOCALES,
        messagesByLocale: localesMessages
    };
};
const initLocale = function (currentState, locale) {
    if (currentState.messagesByLocale.hasOwnProperty(locale)) {
        return Object.assign(
            {},
            currentState,
            {
                isRtl: RtlLocales.indexOf(locale) !== -1,
                locale: locale,
                messagesByLocale: currentState.messagesByLocale,
                messages: currentState.messagesByLocale[locale]
            }
        );
    }
    // don't change locale if it's not in the current messages
    return currentState;
};
export {
    reducer as default,
    initialState as localesInitialState,
    initLocale,
    selectLocale,
    setLocales
};
